<template>
  <div class="today-alarm">
    <div class="bottomtitle dn-title-bg">
      <span class="title">实时曲线</span>
      <div class="buttom dn-content-bg">
        <button v-for="(items,index) in btnarry"
                @click="clickbtn(index)"
                :key="index"
                :id="index"
                :class="activecode==index?' btn btnactive dn-title-bg ':' btn dn-title-bg '">{{items}}
        </button>
      </div>
    </div>
    <div class="bottomrightcontent echartbox">
      <div :id="echartsId"
           class="guanBox"></div>
    </div>
  </div>
</template>
<script>
let vm
import uuidv1 from 'uuid/v1'
export default {
  beforeRouteLeave(to, form, next) {
  },
  props: {
    selectedMeasure: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      btnarry: [
        '电压不平衡度',
        '电流不平衡度',
        '基波电压有效值',
        '基波电流有效值'
      ],
      activecode: 0,
      realTimeData: [],
      echarts: null,
      echartsId: uuidv1(),
      time: 60,
      interTime: null,
      unit:["%","%","V","A"]
    }
  },
  created() {
      console.log(this.activeCode)
  },
  methods: {
    //调接口拿取数据
    getData() {
      let vm = this
      let apiArr = []
    //   vm.activecode = 0
      apiArr.push(
        vm.$api.tmp.getRealTimeVoltageUnbalance(
          vm.selectedMeasure.measureId
        )
      ) //获取电压不平衡度曲线
      apiArr.push(
        vm.$api.tmp.getRealTimeCurrentUnbalance(
          vm.selectedMeasure.measureId
        )
      ) //电流不平衡度曲线
      apiArr.push(
        vm.$api.tmp.getFundamentalVoltage(
          vm.selectedMeasure.measureId
        )
      ) //基波电压有效值曲线
      apiArr.push(
        vm.$api.tmp.getFundamentalCurrent(
          vm.selectedMeasure.measureId
        )
      ) //基波电流有效值曲线
      Promise.all(apiArr)
        .then(resArr => {
            resArr.forEach((item,index)=>{
                if(!item.success){
                    vm.$message.error(item.msg)
                }
            })
          vm.realTimeData = [
            {
              xData: [],
              series: [
                {
                  data: [],
                  name: '电压不平衡',
                  type: 'line',
                  smooth: true
                }
              ],
              legend: ['电压不平衡'],
              title: '电压不平衡'
            },
            {
              xData: [],
              series: [
                {
                  data: [],
                  name: '电流不平衡',
                  type: 'line',
                  smooth: true
                }
              ],
              legend: ['电流不平衡'],
              title: '电流不平衡'
            },
            {
              xData: [],
              series: [],
              legend: [],
              title: '基波电压有效值'
            },
            {
              xData: [],
              series: [],
              legend: [],
              title: '基波电流有效值'
            }
          ]
          vm.realTimeData[0] = vm.matchPow(vm.realTimeData[0], resArr[0].data)
          vm.realTimeData[1] = vm.matchPow(vm.realTimeData[1], resArr[1].data)
          let legend = [
            'A相基波电压有效值',
            'B相基波电压有效值',
            'C相基波电压有效值'
          ]
          vm.realTimeData[2] = vm.matchWave(
            vm.realTimeData[2],
            resArr[2].data,
            legend
          )
          let legendNew = [
            'A相基波电流有效值',
            'B相基波电流有效值',
            'C相基波电流有效值'
          ]
          vm.realTimeData[3] = vm.matchWave(
            vm.realTimeData[3],
            resArr[3].data,
            legendNew
          )
          vm.$nextTick(() => {
            vm.getLineEchart(vm.realTimeData[vm.activecode],vm.unit[vm.activecode])
            if (vm.interTime) {
              clearTimeout(vm.interTime)
            }
            if (vm.time > 0) {
              vm.interTime = setTimeout(() => {
                vm.getData()
              }, vm.time * 1000)
            }
          })
        })
        .catch()
    },
    //匹配电压，电流基波值  lineData图标数据   resDat接口数据   legend图例数据
    matchWave(lineData, resData, legend) {
      let jbdy = []
      for (const i in resData) {
        jbdy.push(resData[i])
      }
      lineData.legend = []
      //基波电流
      jbdy.map((item, i) => {
        lineData.series.push({
          data: [],
          name: legend[i],
          type: 'line',
          smooth: true
        })
        lineData.legend.push(legend[i])
        lineData.xData = []
        item.data.map((temp, j) => {
          lineData.series[i].data.push(
            temp.value == '' ? '' : temp.value.toFixed(2)
          )
          lineData.xData.push(temp.time)
        })
      })
      return lineData
    },
    //匹配电压，电流不平衡值  lineData图标数据   resDat接口数据
    matchPow(lineData, resData) {
      let vm = this
      resData.forEach((item, i) => {
        lineData.xData.push(item.time)
        lineData.series[0].data.push(
          item.dealtvalue == '' ? '' : Number(item.dealtvalue).toFixed(2)
        )
      })
      return lineData
    },
    getLineEchart(obj,unit) {
      let vm = this
      if (vm.echarts == null) {
        vm.echarts = vm.$echarts.init(document.getElementById(vm.echartsId))
      } else {
        vm.echarts.clear()
      }
      var option = {
        legend: {
          height: '80%',
          left: 'center',
          top: '5%',
          data: obj.legend,
          textStyle:{
              color:"#666"
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        color: ['#CCCC00'],
        xAxis: {
          type: 'category',
          data: obj.xData,
          boundaryGap: false,
          axisLine:{
              lineStyle:{
                  color:"#666"
              }
          }
        },
        yAxis: {
          type: 'value',
          name: unit,
          axisLine:{
              lineStyle:{
                  color:"#666"
              }
          }
        },
        series: obj.series
      }
      vm.echarts.setOption(option, true)
      window.addEventListener('resize', function() {
        vm.echarts.resize()
      })
    },
    //实时图标切换tab
    clickbtn(svgcode) {
      let vm = this
      this.activecode = svgcode
      vm.getLineEchart(vm.realTimeData[svgcode],vm.unit[svgcode])
    //    vm.getData()
    },
  },
  watch: {
    selectedMeasure: {
      handler(newVal, oldVal) {
        let vm = this
        // vm.activecode=0
        vm.getData()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.today-alarm{
    height:100%;
    width:100%;
}
.bottomtitle {
    color: #fff;
    font-weight: bold;
    display: flex;
    font-size: 16px;
    justify-content: space-between;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}
.title{
    margin: 5px 0px 5px 5px;
}
.buttom {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
.bottomrightcontent {
    // border-right: 1px solid #eee;
    // border-left: 1px solid #eee;
    // border-bottom: 1px solid #eee;
    height: calc(100% - 33px);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}
.btn {
    display: inline-block;
    height: 1.8rem;
    line-height: 1.9rem;
    border:none;
    padding: 0 0.9rem;
    white-space: nowrap;
    text-align: center;
    font-size: 0.7rem;
    cursor: pointer;
    outline: none;
    font-weight: bold;
    height: 33px;
    color:#fff;
}
.btnactive {
    color: #0197EE !important;
}
.guanBox {
    width: 100%;
    height: 100%;
}
</style>